import script from "./OrderListFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderListFilters.vue?vue&type=script&setup=true&lang=js"

import "./OrderListFilters.vue?vue&type=style&index=0&id=5080b376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5080b376"]])

export default __exports__